import React, { useState, useEffect, useMemo } from 'react';
import './App.css';

const IzinSayfasi = () => {
  const [personeller, setPersoneller] = useState([]);
  const [izinler, setIzinler] = useState([]);
  const [selectedPersonel, setSelectedPersonel] = useState('');
  const [izinTur, setIzinTur] = useState('Yıllık İzin');
  const [basTar, setBasTar] = useState('');
  const [bitTar, setBitTar] = useState('');
  const [basSaat, setBasSaat] = useState('');
  const [bitSaat, setBitSaat] = useState('');
  const [aciklama, setAciklama] = useState('');

  const [holidays, setHolidays] = useState([]);
  const [saturdayMode, setSaturdayMode] = useState('full');
  const [calcDays, setCalcDays] = useState(null);

  const role = localStorage.getItem('role');
  const username = localStorage.getItem('username');

  useEffect(() => {
    fetch(`https://api.idekod.com.tr/api/personel?role=${role}&username=${username}`)
      .then(r => r.json())
      .then(data => {
        setPersoneller(data || []);
        if (role !== '1' && data?.length) {
          setSelectedPersonel(data[0]?.TELNO);
        }
      })
      .catch(err => console.error('Personel bilgileri alınırken hata:', err));

    fetchIzinler();

    fetch('https://api.idekod.com.tr/api/calendar/settings')
      .then(r => r.json())
      .then(d => setSaturdayMode(d?.saturday_mode || 'full'))
      .catch(() => setSaturdayMode('full'));

    fetch('https://api.idekod.com.tr/api/tatiller')
      .then(r => r.json())
      .then(list => {
        const onlyDates = Array.isArray(list) ? list.map(x => x.tarih || x.date || x).map(toISODate) : [];
        setHolidays(onlyDates);
      })
      .catch(() => setHolidays([]));
  }, [role, username]);
  const selectedHolidayCount = useMemo(() => {
  if (!basTar || !bitTar) return 0;

  const start = new Date(basTar);
  const end = new Date(bitTar);

  return holidays.filter(h => {
    const d = new Date(h);
    return d >= start && d <= end;
  }).length;
}, [holidays, basTar, bitTar]);

  const fetchIzinler = () => {
    fetch(`https://api.idekod.com.tr/api/izinler?role=${role}&username=${username}`)
      .then(r => r.json())
      .then(d => setIzinler(Array.isArray(d) ? d : []))
      .catch(err => console.error('İzinler alınırken hata oluştu:', err));
  };

  function toISODate(input) {
    const d = new Date(input);
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
  }

  const calculateLeaveDays = (startStr, endStr) => {
    if (!startStr || !endStr) return null;
    const start = new Date(startStr);
    const end = new Date(endStr);
    if (isNaN(start) || isNaN(end) || start > end) return null;

    let total = 0;
    const holidaySet = new Set(holidays);

    for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
      const iso = toISODate(d);
      const dow = d.getDay();
      if (holidaySet.has(iso)) continue;
      if (dow === 0) continue;
      if (dow === 6) {
        if (saturdayMode === 'off') continue;
        if (saturdayMode === 'half') { total += 0.5; continue; }
        total += 1;
        continue;
      }
      total += 1;
    }
    return total;
  };

  // Günlük ve Saatlik izinler hakedişten düşmez
  const hakedistenDuser = izinTur === 'Yıllık İzin';

  useEffect(() => {
    if (!hakedistenDuser) { setCalcDays(0); return; }
    setCalcDays(calculateLeaveDays(basTar, bitTar));
  }, [basTar, bitTar, izinTur, hakedistenDuser, holidays, saturdayMode]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedPersonel) {
      alert('Lütfen kullanıcı seçin.');
      return;
    }
    try {
      const kontrolRes = await fetch('https://api.idekod.com.tr/api/izin/kontrol', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          telno: selectedPersonel,
          izintur: izinTur,
          bastar: basTar,
          bittar: bitTar,
          bassaat: izinTur === 'Saatlik İzin' ? basSaat : null,
          bitsaat: izinTur === 'Saatlik İzin' ? bitSaat : null,
          aciklama,
          calcDays:calcDays
        })
      });
      const kontrolData = await kontrolRes.json();
      if (!kontrolRes.ok || !kontrolData?.success) {
        alert(kontrolData?.message || 'İzin kontrolü/kayıt başarısız.');
        return;
      }
      alert(kontrolData.message || 'İzin kaydedildi.');
      window.location.reload();
      if (typeof fetchIzinler === 'function') fetchIzinler();
    } catch (err) {
      console.error(err);
      alert('Sunucuya erişilirken hata oluştu.');
    }
  };

  const secilenKisi = useMemo(
    () => personeller.find(p => String(p.TELNO) === String(selectedPersonel)),
    [personeller, selectedPersonel]
  );

  return (
    <div className="page">
      <div className="page__head">
        <div>
          <h1 className="page__title">İzin Kayıt</h1>
          <p className="page__subtitle">Yeni izin talebi oluşturun ve onaya gönderin</p>
        </div>
      </div>

      <div className="card">
        <div className="card__header">
          <h2 className="card__title">İzin Talep Formu</h2>
        </div>

        <form onSubmit={handleSubmit} className="card__body form">
          {role === '1' && (
            <>
              <div className="form-field">
                <label className="form-label">Kullanıcı</label>
                <select
                  value={selectedPersonel}
                  onChange={(e) => setSelectedPersonel(e.target.value)}
                  className="form-control"
                >
                  <option value="">Kullanıcı Seç</option>
                  {personeller.map(p => (
                    <option key={p.TELNO} value={p.TELNO}>{p.RNAME}</option>
                  ))}
                </select>
              </div>

              {selectedPersonel && (
                <div className="info-banner">
                  Hakedişiniz: <strong>{secilenKisi?.HAKEDISI ?? '-'}</strong>
                </div>
              )}
            </>
          )}

          <div className="form-field">
            <label className="form-label">İzin Türü</label>
            <select
              value={izinTur}
              onChange={(e) => setIzinTur(e.target.value)}
              className="form-control"
            >
              <option value="Yıllık İzin">Yıllık İzin</option>
              <option value="Günlük İzin">Günlük İzin</option>
              <option value="Saatlik İzin">Saatlik İzin</option>
            </select>
          </div>

          <div className="form-grid">
            <div className="form-field">
              <label className="form-label">Başlangıç Tarihi</label>
              <input
                type="date"
                value={basTar}
                onChange={(e) => setBasTar(e.target.value)}
                required
                className="form-control"
              />
            </div>
            <div className="form-field">
              <label className="form-label">Bitiş Tarihi</label>
              <input
                type="date"
                value={bitTar}
                onChange={(e) => setBitTar(e.target.value)}
                required
                className="form-control"
              />
            </div>
          </div>

          {izinTur === 'Saatlik İzin' && (
            <div className="form-grid">
              <div className="form-field">
                <label className="form-label">Başlangıç Saati</label>
                <input
                  type="time"
                  value={basSaat}
                  onChange={(e) => setBasSaat(e.target.value)}
                  required
                  className="form-control"
                />
              </div>
              <div className="form-field">
                <label className="form-label">Bitiş Saati</label>
                <input
                  type="time"
                  value={bitSaat}
                  onChange={(e) => setBitSaat(e.target.value)}
                  required
                  className="form-control"
                />
              </div>
            </div>
          )}

          <div className="form-field">
            <label className="form-label">Açıklama</label>
            <textarea
              value={aciklama}
              onChange={(e) => setAciklama(e.target.value)}
              placeholder="Açıklama Giriniz"
              className="form-control"
            />
          </div>

          {izinTur !== 'Saatlik İzin' && (
            <div className="stat-grid">
              <div className="stat-tile">
                <div className="stat-tile__label">Hafta Sonu Kuralı</div>
                <div className="stat-tile__value">
                  {saturdayMode === 'half' ? 'Yarım gün say' :
                    saturdayMode === 'off' ? 'Cumartesi sayma' : 'Tam gün say'}
                </div>
              </div>
              <div className="stat-tile">
                <div className="stat-tile__label">Tatiller</div>
               <div className="stat-tile__value">
  {selectedHolidayCount > 0
    ? `${selectedHolidayCount} gün`
    : 'Yok'}
</div>
              </div>
              <div className="stat-tile">
                <div className="stat-tile__label">Bu izin için düşecek</div>
                <div className="stat-tile__value">
                  {!hakedistenDuser ? 'Hakedişten düşmez' : (calcDays == null ? '-' : calcDays)}
                </div>
              </div>
            </div>
          )}

          <button type="submit" className="btn btn--primary btn--block btn--lg">
            Kaydet ve Onaya Gönder
          </button>
        </form>
      </div>
    </div>
  );
};

export default IzinSayfasi;
